import axios from "axios";
import {
  getMyReferralCodeUrl,
  createReferralUrl,
  getMyReferralsUrl,
  getMyRewardsUrl,
  getMyStatsUrl,
  getLeaderboardUrl,
} from "../utils/urls";

export const getMyReferralCode = async () => {
  const res = await axios.get(getMyReferralCodeUrl);
  return res?.data?.data;
};

export const createReferral = async (payload) => {
  const res = await axios.post(createReferralUrl, payload);
  return res?.data?.data;
};

export const getMyReferrals = async () => {
  const res = await axios.get(getMyReferralsUrl);
  return res?.data?.data;
};

export const getMyRewards = async () => {
  const res = await axios.get(getMyRewardsUrl);
  return res?.data?.data;
};

export const getMyStats = async () => {
  const res = await axios.get(getMyStatsUrl);
  return res?.data?.data;
};

export const getLeaderboard = async () => {
  const res = await axios.get(getLeaderboardUrl);
  return res?.data?.data;
};
